import { Component, ElementRef, Renderer2, ViewChild, ViewChildren, AfterViewInit, QueryList, HostListener, ChangeDetectorRef  } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { NgbModal, NgbModalRef, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import { AnalyticsService } from '../../services/analytics.service';
import { ProductService } from '../../services/product.service';
import { GlobalRecordService } from '../../services/global-record.service';
import { AlbumsService } from '../../services/albums.service';
import { SearchService } from '../../search/services/search.service';
import { BlockUIService } from '../../layout/block-ui/block-ui.service';
import { formatString } from '../../utils/string-utils';
import { SearchResults, Criterion } from '../../models/search-objects.interface';
import { SaveSearchComponent } from '../../saved-search/save-search/save-search.component';
import { BrowseEditComponent } from '../../browse/components/browse-edit/browse-edit.component';
import { AlertsService } from '../../services/alerts.service';
import { ConfirmComponent } from '../../components/confirm/confirm.component';
import { ImageRotateComponent } from '../../components/image-rotate/image-rotate.component';
import { LibraryMoveComponent } from '../../components/library-move/library-move.component';
import { EmailProductsComponent } from '../../components/email-products/email-products.component';
import { PrintResultsComponent } from '../../components/print-results/print-results.component';
import { DiffViewerComponent } from '../../components/diff-viewer/diff-viewer.component';
import { MassDownloadComponent } from '../../download/mass-download/mass-download.component';
import { BatchAddComponent } from '../../workflow/components/batch-add/batch-add.component';
import { RecordFilingComponent } from '../../records-management/components/record-filing/record-filing.component';
import { AlbumItemComponent } from '../../albums/album-item/album-item.component';
import { FilingService } from '../../records-management/services/filing.service';
import { CitationComponent } from '../../components/citation/citation.component';
import { DocViewerFactoryService } from '../../services/factory/doc-viewer-factory.service';
import { ViewportService } from '../../services/viewport.service';
import { RoutingService} from '../../services/routing.service';
import { FeatureService } from '../../services/feature.service';
import { GlobalEditComponent } from '../../edit/global-edit/global-edit.component';
import { MapService } from '../../map/services/map.service';
import { GeoTagComponent } from '../../map/geo-tag/geo-tag.component';


/**
 * Main search component.
 */
@Component({
	selector: 'search',
	templateUrl: './search.component.html',
	styleUrl: './search.component.css'
})
export class SearchComponent implements OnInit, OnDestroy, AfterViewInit {
	
	LOCALIZATION: any = {};
    
    query: string | null = '';
    aoi: string | null = '';
    aoiCriteria: string | null = '';
    criteria: { [key: string]: Criterion } = {};
    pageIndex: number = 1;
	userPermissions: { [key: string]: any } = {};
	element: Element | null = null;
	viewerMode: string = 'Filters';
	citationsEnabled: boolean = false;
	globalRecordIdsHash: Record<string, any> = {};
	globalRecordIds: string[] = [];
	globalRecords: any = { all: false };
	projectionUnits: any[] = [];
	isLastExtent: boolean = true;
	isFirstExtent: boolean = true;
	browseEnabled: boolean = false;
	mapViewEnabled: boolean = false;
	aiServicesEnabled: boolean = false;
	recordsMgmtServicesEnabled: boolean = false;
	docViewsEnabled: boolean = false;
    isMoreLikeThisEnabled: boolean = false;
    streamingQueries: any = {};
    dxOn: boolean = false;
	multiFacetSearch: boolean = false;
	multiFacetBlacklist: string[] = [];
	paginationGoTo: boolean = false;
	ocr: any = { available: false };
	simpleview: any = {};
	pager: any = {};
	searchResults: SearchResults | null = null;
	mapDetached: boolean = false;
	private timer: any;
	mapViewedOnce: boolean = false;
	overflowed: boolean = false;
	states: any = {};
	params: any = {};
	validFieldsShow: any[] = [];
	sortFieldsShow: any[] = [];
	sort: any = {};
	docIDOpen:string = '-1';
	user: any = {};
	pageSizes: any[] = [{ name: 25, value: 25 }, { name: 50, value: 50 }, { name: 75, value: 75 }, { name: 100, value: 100 }];
    popularity: any = {};
    rank: any = {};
    defaultUserSort: any = {};
    defaultField: boolean = false;
    direction: string | null = null;
    defaultFieldName: string | null = null;
    additionalIcons: boolean = false;
    group: { [key: string]: boolean } = {
	    criteria: true,
	    AOI: false,
	    searches: false,
	    locations: false,
	    facets: false,
	    browse: false
    };
    sidebar: any = {
        oneAtATime: true,
        panelStyles: {}
    };
    screen: any = {};
    resizeVar: boolean = false;
    records: any[] = [];
    modalRef: NgbModalRef | undefined;
    browseOpen: boolean = false;
    critCount: number = 0;
    isMobile: boolean = false;
    loading$: Observable<boolean>;
    message$: Observable<string>;
    
	@ViewChild('resizer') resizer!: ElementRef;
	@ViewChild('leftSide') leftSide!: ElementRef;
    @ViewChild('rightSide') rightSide!: ElementRef;
    @ViewChild('dropdown') dropdown!: NgbDropdown;  // Access the ngbDropdown directive
    @ViewChildren(NgbDropdown) dropdowns!: QueryList<NgbDropdown>;
     
    private startX: number = 0;
    private leftWidth: number = 0;
	private resizerMouseDownListener: (() => void) | null = null;
	private initializationDone = false;
	
    private searchServiceSubscription: Subscription = new Subscription();
    private userServiceSubscription: Subscription = new Subscription();
    private globalRecordServiceSubscription: Subscription = new Subscription();
	private mapServiceSubscription!: Subscription;
	private routingEventSubscription!: Subscription;
	private userEventSubscription!: Subscription;
    
	mainContentStyling: { height?: string } = {};
  
	constructor(
		private userService: UserService,
		private analyticsService: AnalyticsService,
		private configService: ConfigService,
		public globalRecordService: GlobalRecordService,
		private searchService: SearchService,
		private el: ElementRef,
		private breakpointObserver: BreakpointObserver,
		private renderer: Renderer2,
		private sanitizer: DomSanitizer,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private route: ActivatedRoute,
		private ngbModal: NgbModal,
		private alertsService: AlertsService,
		private productService: ProductService,
		private filingService: FilingService,
		private albumsService: AlbumsService,
		private viewportService: ViewportService,
		private routingService: RoutingService,
		private mapService: MapService,
		private blockUI: BlockUIService,
		private docViewerFactory: DocViewerFactoryService,
		private featureService: FeatureService
	) {
		this.loading$ = blockUI.loading;
        this.message$ = blockUI.message;
	}

	ngOnInit(): void {
		const params = { ...this.routingService.getQueryParams()};
		console.log("---------CALL SEARCH ngOnInit() "+JSON.stringify(params));
		
		this.processCurrentViewState();
			
		if (this.searchService.query){
			this.query = this.searchService.query;
		}
		
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.userPermissions = this.userService.getUserPermissionsMap();
		
		this.setFromConfiguration();
		this.setDefaultValues();
	    this.searchService.clearSearch();
		this.doCleanSearches();
		
	    this.element = this.el.nativeElement.querySelector('#modal-holder');
		
		this.viewerMode = 'Filters';
		this.params = { ...params };
		if (params['browseconfig']) {
            this.searchService.setBrowseConfig(JSON.parse(params['browseconfig']));
        } else {
			this.searchService.setBrowseConfig({});
		}
        this.browseEnabled = this.configService.getConfig().browse.enabled;
        if (params['b'] && params['b'] == '1') {
            this.browseEnabled = true;
        }
        
        if (params['mapDetach'] && params['mapDetach'] == "true") {
            this.mapDetached = true;
            this.searchService.mapDetached = true;
			this.changeView("G");
            window.addEventListener('storage', this.onMessageReceive);
        }
        
		const detachedParam = params['detached'];
	    const queryParam = params['q'];
	
	    const detached = detachedParam ? this.sanitize(detachedParam) === 'true' : false;
	    const query = queryParam ? this.sanitize(queryParam) : '';
	
	    this.states = {
	      detached: detached,
	      advancedOpen: !(detached || this.mapDetached),
	      browseOpen: this.browseOpen,
	      query: query,
	      mapDetach: this.mapDetached
	    };
		
        this.pager = {
          size: this.searchService.pageSize
        }; 
		   
		if (params['a']) {
            this.group['criteria'] = false;
            this.group['AOI'] = false;
            this.group['searches'] = false;
            this.group['locations'] = false;
            this.group['facets'] = false;
            this.group['browse'] = false;

            if (params['a'] == "a") {
                this.group['AOI'] = true;
            } else if (params['a'] == "c") {
                this.group['criteria'] = true;
            } else if (params['a'] == "s") {
                this.group['searches'] = true;
            } else if (params['a'] == 'l') {
                this.group['locations'] = true;
            } else if (params['a'] == 'f') {
                this.group['facets'] = true;
            } else if (params['a'] == 'b') {
                this.group['browse'] = true;
            }
        }
		
        this.sidebar.panelStyles = {};
        this.setDefaultQueryType();
        if (this.userService.user.systemPreferences) {
            this.initializeProps();
            this.searchService.instantiateSearchParms(this.params);
        }
        this.handleOverflow();
        this.user = this.userService.user;
        if (this.user.permissions) {
			let permissions = this.user.permissions.reduce((map: Record<string, number>, obj: string) => {
			  map[obj] = 1;
			  return map;
			}, {});

            this.userPermissions = permissions;
            
			if (params['docid']) {
				const viewerComponent = this.docViewerFactory.getViewerComponent();
				const modalRef = this.ngbModal.open(viewerComponent, {
					windowClass: "viewer-modal-window"
				});
				
				modalRef.componentInstance.productId = params['docid'];

				modalRef.result.then(
					(payload) => {
						console.log('Modal dismissed');
					},
					(reason) => {
						console.log('Modal dismissed');
					}
				);
			}
        }
        
	    this.viewportService.isMobile$.subscribe(isMobile => {
			this.isMobile = isMobile;
		});
		
		this.searchServiceSubscription = this.searchService.broadcastEvent.subscribe((args: any) => {
			switch (args.type) {
				case 'closeModal':
					this.onCloseModal();
					break;
				case 'cleanSearches':
					if (this.mapDetached) {
						this.message_broadcast({ 'action': 'clearSearch' });
					}
					this.globalRecordService.clear();
					this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
					this.globalRecordIds = [];
					break;
				case 'switchViewerMode':
					if (args.data.mode) {
						this.viewerMode = args.data.mode;
					}
					break;
				case 'mapDetachSearch':
					let data = {
						pageIndex: this.searchService.pageIndex,
						pageSize: this.searchService.pageSize
					}
					this.message_broadcast({ 'action': 'updateSearch', 'data': data })
					break;
				case 'clearSearch':
					this.onClearSearch();
					break;
				case 'searchStarted':
					this.states.query = this.searchService.query;
					this.states.type = this.searchService.type
					break;
				case 'searchEnded':
					this.onSearchEnded(args.data);
					break;
				case 'globalrecorddeselectAll':
					Object.keys(this.globalRecordIdsHash).forEach((id: string) => {
						this.globalRecordService.setRecord(Number(id), false);
					});
					this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
					break;
				case 'globalrecordselectAll':
					Object.keys(this.globalRecordIdsHash).forEach((id: string) => {
						this.globalRecordService.setRecord(Number(id), true);
					});
					this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
					break;
				case 'userTriggeredSearchExecution':
					this.states.type = this.searchService.type
					break;
				case 'sortChanged':
					this.onSortChanged(args.data);
					break;
				case 'openBrowseLink':
					this.openBrowseLink(args.data);
					break;	
			}
		});
	    
	    this.userServiceSubscription = this.userService.broadcastEvent.subscribe((eventId: string) => {
		  switch (eventId) {
	       case 'localizationLoaded':
			 this.LOCALIZATION = this.userService.LOCALIZATION;
	         this.popularity.displayName = this.LOCALIZATION.popularity;
	         this.rank.displayName = this.LOCALIZATION.rank;
	         break;
	       case 'userPrefsUpdate':
			 this.onUserPrefsUpdate()
	         break;  
          }
	    });
		
		this.globalRecordServiceSubscription = this.globalRecordService.recordSelectEvent.subscribe((args: any) => {
			switch (args.eventType) {
				case 'recordSelection':
					console.log("Processing event for " + JSON.stringify(args));
					this.globalSelectRecord(args.recordId);
					break;
			}
		});
		
		// Listen for route changes, specifically related to the view type
		this.routingEventSubscription = this.routingService.routingEvent.subscribe(event => {
			if (event.eventType === 'viewTypeChanged') {
				this.processCurrentViewState();
			}
		});
		
		this.mapServiceSubscription = this.mapService.mapServiceEvent.subscribe(event => {
			if (event.eventType === 'openRecordInMap') {
				this.changeView('M');
			}
		});

		/* TODO
		// from searchbar.html, not migrated yet
		this.$watch('states.type', function(newValue, oldValue) {
		    if (newValue !== oldValue) {
				this.setSortField($scope?.sort?.field, $scope?.sort?.direction);
		    }
		});
		*/
	
	    this.citationsEnabled = this.configService.getConfig().menu ? this.configService.getConfig().menu.citations : false;
		// NOTE: switched to an Angular shared data service 
		this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
	    this.userService.isFacadeEnabled('OCRFacade').then(
			(available: boolean) => {
				this.ocr.available = available;
			},
			(err: any) => {
				this.ocr.available = false;
			}
		);
		
		if (!this.userService.user?.loggedin && !this.configService.getConfig().auth?.public?.autoEnabled) {
			this.userService.goHome();
		}
	}
	
	ngOnDestroy() {
		this.searchService.exitStates = this.states;
		if (this.userEventSubscription) {
			this.userEventSubscription.unsubscribe();
		}

		if(this.searchServiceSubscription){
			this.searchServiceSubscription.unsubscribe();
		}
		
		if (this.timer) {
		  clearInterval(this.timer);
		}
		
  		window.removeEventListener('storage', this.onMessageReceive);
  		
  		if (this.resizerMouseDownListener) {
		  this.resizerMouseDownListener();
		  this.resizerMouseDownListener = null;
		}
		
		if (this.userServiceSubscription) {
			this.userServiceSubscription.unsubscribe();
		}
		
		if (this.globalRecordServiceSubscription) {
			this.globalRecordServiceSubscription.unsubscribe();
		}
		
		if (this.routingEventSubscription) {
			this.routingEventSubscription.unsubscribe();
		}
		
		if (this.mapServiceSubscription) {
			this.mapServiceSubscription.unsubscribe();
		}
	}

	ngAfterViewInit() {
		if (this.resizer) {
			this.resizerMouseDownListener = this.renderer.listen(this.resizer.nativeElement, 'mousedown', (event: MouseEvent) => {
				this.startX = event.clientX;
				this.leftWidth = this.leftSide.nativeElement.getBoundingClientRect().width;

				const mouseMoveHandler = (e: MouseEvent) => {
					const dx = e.clientX - this.startX;
					const newLeftWidth = ((this.leftWidth + dx) * 100) / this.resizer.nativeElement.parentNode.getBoundingClientRect().width;

					// Disable pointer events during resize to prevent selection issues
					this.renderer.setStyle(this.leftSide.nativeElement, 'userSelect', 'none');
					this.renderer.setStyle(this.leftSide.nativeElement, 'pointerEvents', 'none');
					this.renderer.setStyle(this.rightSide.nativeElement, 'userSelect', 'none');
					this.renderer.setStyle(this.rightSide.nativeElement, 'pointerEvents', 'none');

					// Change cursor to indicate resizing
					this.renderer.setStyle(this.resizer.nativeElement, 'cursor', 'col-resize');

					// Apply new width
					this.renderer.setStyle(this.leftSide.nativeElement, 'width', `${newLeftWidth}%`);
				};

				const mouseUpHandler = () => {
					// Restore pointer events after resizing
					this.renderer.removeStyle(this.leftSide.nativeElement, 'userSelect');
					this.renderer.removeStyle(this.leftSide.nativeElement, 'pointerEvents');
					this.renderer.removeStyle(this.rightSide.nativeElement, 'userSelect');
					this.renderer.removeStyle(this.rightSide.nativeElement, 'pointerEvents');

					// Restore cursor to default
					this.renderer.removeStyle(this.resizer.nativeElement, 'cursor');

					// Remove event listeners
					document.removeEventListener('mousemove', mouseMoveHandler);
					document.removeEventListener('mouseup', mouseUpHandler);
				};
				document.addEventListener('mousemove', mouseMoveHandler);
				document.addEventListener('mouseup', mouseUpHandler);
			});
		}
		
		setTimeout(() => {
			this.updateMainContentHeight();
		});
	}

	private updateMainContentHeight() {
		const screenHeight = window.innerHeight;

		if (screenHeight > 0) {
			let calculatedHeight = this.viewportService.calculateMainContentHeight();
			this.mainContentStyling = { height: `${calculatedHeight}px` };
		}
	}
	
	private processCurrentViewState(): void {
		let newView = this.routingService.getQueryParam('v');
		if (newView && this.states.currentView !== newView) {
			this.states.currentView = newView;
		}
		if (!this.states.currentView) {
			this.states.currentView = 'G';
		}
		
		console.log(`Current view: ${this.states.currentView}`);
	}
	
    toggleViewMode(mode: string){
	    this.viewerMode = mode;
	}
	
	doCleanSearches() {
		this.searchService.clearSearches(false);
		this.searchService.broadcastEvent.emit({ type: 'cleanSearches', data: {} });
	}
	
    clearAOI() {
		const params = this.routingService.getQueryParams();
		this.mapService.broadcastClearAOIEvent({query: params['q'] || ''});
    }
	
    download (record: any) {
		const downloadUrl = formatString(this.configService.getConfig().document.documentDownloadURL,record.id);
		window.open(downloadUrl, '_blank');
    }
	
	handleOverflow() {
		const width = window.innerWidth;

		// Update pagination links size
		this.pager.paginationLinks = width < 940 ? (this.paginationGoTo ? 2 : 3) : (this.paginationGoTo ? 2 : 5);
	}
  
  message_broadcast = function (message: any): void {
    localStorage.setItem('map_message', JSON.stringify(message))
    localStorage.removeItem('map_message');
  };
  
  // change name from message_receive
  @HostListener('window:storage', ['$event'])
  onMessageReceive(event: StorageEvent) {
	//console.log('Storage event triggered:', event);
    if (event.key !== 'map_message') return; // Ignore other keys
    const message = event.newValue ? JSON.parse(event.newValue) : null;
    if (!message) return; // Ignore empty message

    //console.log(message);

    switch (message.action) {
      case 'updateMapRecordPreview':
        this.handleUpdateMapRecordPreview(message.data);
        break;
      case 'zoomToGeo':
        this.handleZoomToGeo(message.data);
        break;
      case 'updateSearch':
        this.handleUpdateSearch(message.data);
        break;
      case 'clearSearch':
        this.handleClearSearch();
        break;
    }
  }
  
  @HostListener('window:resize', ['$event'])
	onResize(event: any): void {
	  setTimeout(() => {
		this.updateMainContentHeight();
		
	    this.resizeVar = !this.resizeVar;
	    
	    // Update current scope based on new innerWidth and let Angular update the view
	    this.handleOverflow();
	    this.searchService.broadcastEvent.emit({type:'recordPreviewReset',data:{}});
	    this.searchService.broadcastEvent.emit({type:'loadDraggable',data:{}});
	    
	    this.viewerMode = event.target.innerWidth >= 768 ? 'Filters' : this.viewerMode;
	  }, 100);
	}
  
	private handleUpdateMapRecordPreview(data: any) {
		if (data) {
			// Assuming searchResults is available in this component
			const matchingRecords = this.searchResults && this.searchResults.records ? this.searchResults.records.filter(x => x.id === data.uuid) : [];
			if (matchingRecords.length > 0) {
				setTimeout(() => {
					console.log("Broadcast: scrollToRecord", data);
					this.searchService.broadcastEvent.emit({ type: 'scrollToRecord', data });
					console.log("Broadcast: updateMapRecordPreview", { uuid: data.uuid, forceZoom: false });
					this.mapService.broadcastUpdatePreviewEvent({
							uuid: data.uuid,
							forceZoom: false
						});
				}, 200);
			}
		} else {
			setTimeout(() => {
				console.log("Broadcast: clearSelectedRecord");
				this.searchService.broadcastEvent.emit({ type: 'clearSelectedRecord', data: {} });
			}, 200);
		}
	}

	private handleZoomToGeo(data: any) {
		let messageData = data || {};
		console.log("Broadcast: Zoom&SelectRecord", data);
		this.mapService.broadcastZoomSelectRecordEvent(messageData);
	}

  private handleUpdateSearch(data: any) {
	let messageData = data || {};
    console.log("Broadcast: userTriggeredSearchExecution", {
      searchObj: data,
      notify: false,
      pageIndex: data.pageIndex,
      pageSize: data.pageSize
    });
    this.searchService.broadcastEvent.emit({type:'userTriggeredSearchExecution',data:{
                            searchObj: data,
                            notify: false,
                            pageIndex: data.pageIndex,
                            pageSize: data.pageSize
                        }});
  }

  private handleClearSearch(): void {
    console.log("Broadcast: cleanSearches");
    this.searchService.broadcastEvent.emit({type:'cleanSearches',data:{}});
    this.globalRecordService.clear();
    this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
    this.globalRecordIds = [];
  }
  
changeView(view: string | null, dropdown?: NgbDropdown): void {
    let v: string | null = null;

    switch (view) {
      case 'L':
        v = 'L';
        break;
      case 'G':
        v = 'G';
        break;
      case 'M':
        v = this.mapViewEnabled ? 'M' : 'G';
        break;
      case 'T':
        v = 'T';
        break;
      case 'S':
        v = 'S';
        break;
      case 'R':
        v = this.recordsMgmtServicesEnabled ? 'R' : 'L';
        break;
      default:
        if (this.userService.user?.properties) {
          const property = this.userService.user.properties.awpropertyObjectList?.find(
            (prop: any) => prop.name === 'RESULT_LIST_DISPLAY_TYPE'
          );
          switch (property?.value) {
            case '1':
              v = 'G';
              break;
            case '2':
              v = 'L';
              break;
            case '3':
              v = 'T';
              break;
            case '4':
              v = this.mapViewEnabled ? 'M' : 'G';
              break;
            default:
              v = 'G';
          }
        } else {
          v = 'G';
        }
        break;
    }

    this.states.currentView = v;
    this.routingService.updateSearchUrl({"v": v}, false);
    //this.searchService.instantiateSearchParms(params);
    if (v === 'M') {
      if (!this.mapViewedOnce) {
		this.searchService.broadcastEvent.emit({type:'map:FullExtent',data:{}});
        this.mapViewedOnce = true;
      }
      this.searchService.broadcastEvent.emit({type:'toggleAdvanced',data:{ toggle: 'M' }});
      this.searchService.broadcastEvent.emit({type:'grid:flashMapRecordPriview',data:{}});
    }
   
    if (dropdown && dropdown.isOpen()) {
    	dropdown.close(); // closes the dropdown
    }
  }
  
  updateFlow(val: boolean): void {
    this.overflowed = val;
  }
  
  onClearSearch(){
	this.searchResults = null;
	this.states.query = null;
    this.criteria = {};
    this.params = {};
    this.overflowed = false;
    this.aoiCriteria = null;
    this.globalRecordService.clear();
	this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
    this.globalRecordIds = [];
    this.globalRecords.all = false;
	this.searchService.broadcastEvent.emit({ type: 'clearVisualTree', data: {} });
  }
  
  numberWithCommas(x: number = 0): string {
    if (!x)
        return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  updatePageGap(): void {
   if (this.searchResults) {  
    if (this.searchResults.total == 0) {
      this.searchResults.pageGap = "0";
      return;
    }

    // Using `|| 1` to ensure that `this.searchResults.page` defaults to 1 if it's undefined or falsy
    let currentPage = this.searchResults.page || 1;
    let firstPage = 1 + (this.pager.size * (currentPage - 1));
    let lastPage = (this.pager.size * 1) + (this.pager.size * (currentPage - 1));
    lastPage = lastPage > (this.searchResults?.total ?? 0) ? (this.searchResults?.total ?? 0) : lastPage;

    this.searchResults.pageGap = firstPage + " - " + lastPage;
   }
  };

  pageChanged() {
    this.pager.goToPage = this.pager.page;
    this.searchService.update_pagingSorting({
        pageSize: this.pager.size,
        pageIndex: this.pager.page,
        sortDirection: this.searchService.sortDirection,
        sortField: this.searchService.sortField
    });
  };

	goToPage(newPage?: number) {
		if (newPage) {
			this.pager.goToPage = newPage;
		}
		if (this.pager.goToPage > this.pager.totalPages || this.pager.goToPage < 1) {
			//reset to current page
			this.pager.goToPage = this.pager.page;
		}
		if (typeof this.pager?.goToPage === 'number' && (this.pager.goToPage % 1) === 0) {
			this.pager.page = this.pager.goToPage;
			this.pageChanged();
		} else {
			//reset to current page
			this.pager.goToPage = this.pager.page;
		}
	}
    
  sortIsHidden(sort: any): boolean {
	if ("AW5_SORT_BY_FINE_RANK" == sort.name) {
		let allowedQueryTypes = [3, 16, 32, 64];
		return this.configService.getConfig().search.hideRank === true || this.states.type && !allowedQueryTypes.includes(Number(this.states.type));
	}
	return false;
  }     
  
  sortHideFilter (sort: any): boolean {
	return !this.sortIsHidden(sort);
  }
  
  setSortField (field: any, sortDirection: string | undefined) {
	if (this.sortIsHidden(field)) {
		let fidx = this.validFieldsShow.findIndex((vf)=>{
		    return vf.name === field.name;
		});
		let nextidx = fidx+1 < this.validFieldsShow.length ? fidx+1 : 0;
		field = this.validFieldsShow[nextidx];
	}
	if (this.sort?.field?.name == field.name) {
	    this.sort.direction = sortDirection ? sortDirection : (this.sort.direction == "ASC" ? "DESC" : "ASC");
	}
	else {
		if(!sortDirection && field.name!='AW5_SORT_BY_FINE_RANK'){
			sortDirection = 'ASC';
		}
	    this.sort = {
	        direction: sortDirection ? sortDirection : "DESC",
	        field: field
	    }
	}
  }
  
  onSortSelected(field: any, dropdown?: NgbDropdown): void {
    this.sortChanged(field); // your sorting logic
    if(dropdown && dropdown.isOpen()) {
    	dropdown.close(); // closes the dropdown
    }
    let sortDirection = "NONE";
    if (this.sort?.field?.name == field.name) {
	    sortDirection = this.sort.direction == "ASC" ? "DESC" : "ASC";
	}
	else if(sortDirection === "NONE" && field.name!='AW5_SORT_BY_FINE_RANK'){
		sortDirection = 'ASC';
	}
	
    //this.searchService.broadcastCustomEvent('gridChangeOrder',{'field' : field, 'direction':sortDirection});
  }
  
  sortChanged (field: any, sortDirection?: string, isInit?: boolean) {
        //we don't want to set this variable during the initial sort setup
        if (this.configService.getConfig().search.multiFacetSearch && !isInit) {
           this.searchService.broadcastEvent.emit({type:'facetPreserved',data:{}});
        }

		this.setSortField(field, sortDirection);

        this.searchService.update_pagingSorting({
            pageSize: this.searchService.pageSize,
            pageIndex: 1,
            sortDirection: this.sort.direction,
            sortField: field.name
        });
	this.searchService.broadcastEvent.emit({type:'updateGridSort',data:{ direction: this.sort.direction, field: field }});
  }
  
  pageSizeChanged (size: number, dropdown: NgbDropdown) {
        this.pager.size = size;
        this.pager.page = 1;
		let totalResults = this.searchResults?.total || 0;
        this.pager.totalPages = Math.ceil(totalResults / this.pager.size);
        this.searchService.update_pagingSorting({
            pageSize: this.pager.size,
            pageIndex: this.pager.page,
            sortDirection: this.searchService.sortDirection,
            sortField: this.searchService.sortField
        });
        if(dropdown && dropdown.isOpen()) {
    		dropdown.close(); // closes the dropdown
        }
    };

  onUserPrefsUpdate(){
	this.initializeProps();
    this.searchService.instantiateSearchParms(this.params);
    this.handleOverflow();
    this.user = this.userService.user;
    if (this.user.permissions) {
        let permissions = this.user.permissions.reduce((map: Record<string, number>, obj: string) => {
		  map[obj] = 1;
		  return map;
		}, {});
        this.userPermissions = permissions;
        const params = { ...this.routingService.getQueryParams()};
        if (params['docid'] && (!this.docIDOpen || this.docIDOpen!==params['docid'])) {
            this.docIDOpen=params['docid'];
           
			const viewerComponent = this.docViewerFactory.getViewerComponent();
			const modalRef = this.ngbModal.open(viewerComponent, {
				windowClass: "viewer-modal-window"
			});
			
			modalRef.componentInstance.productId = params['docid'];

			modalRef.result.then(
			    (payload) => {
			        console.log('Modal dismissed');
			    },
			    (reason) => {
			        console.log('Modal dismissed');
			    }
			);			
        }
    }
    if (this.user.properties) {
        for (const prop in this.user.properties.awpropertyObjectList) {
		  if (Object.prototype.hasOwnProperty.call(this.user.properties.awpropertyObjectList, prop)) {
		    const property = this.user.properties.awpropertyObjectList[prop];
		
		    if (property.name === "NUMBER_DOCUMENTS_PER_PAGE") {
		      this.pageSizes = property.optionElementList;
		      this.pager.size = property.value;
		      this.searchService.pageSize = property.value;
		    }
		  }
		}
    }
  }
  
  onSearchEnded(results: any) {
	this.viewerMode = 'Results';
	
    let query = this.searchResults?.query || '';
    if (results.error) {
      this.searchResults = { records: [],error: this.LOCALIZATION.noServerResponse };
    } else {
      this.searchResults = results;
      this.pager.page = results.page;
      this.pager.goToPage = results.page;
      this.pager.totalPages = Math.ceil(results.total / this.pager.size);
      this.updatePageGap();
      this.records = results.records;
    }

    this.overflowed = this.isOverflowedCandidate();
    this.criteria = Object.keys(this.searchService.criteria || {}).length > 0 ? this.searchService.criteria : {};
    this.critCount = Object.keys(this.searchService.criteria || {}).length;
    this.aoiCriteria = this.searchService.aoi;

    this.globalRecordService.clear();
    this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
    this.globalRecordIds = [];
    this.globalRecords.all = false;

    if (results.query && query !== results.query && this.states.currentView === 'M') {
      this.searchService.broadcastEvent.emit({type:'toggleAdvanced',data:{ toggle: 'M' }});
    }

	if (this.criteria && this.criteria['album_id']) {
	  const albumCriteria = this.criteria['album_id']; // ✅ safe local reference
	  const match = albumCriteria.searchParam.match(/\d+$/);
	  const albumid = match ? match[0] : null;
	
	  if (albumid) {
	    albumCriteria.display_value = this.LOCALIZATION.loading;
	    this.albumsService.getMinimalAlbumDescription(albumid).then(
	      (album: any) => {
	        albumCriteria.display_value = album.name;
	      },
	      () => {
	        albumCriteria.display_value = albumid;
	      }
	    );
	  }
	}

      const facets = results.facets;
      const search = results.query;
	  this.analyticsService.trackEvent('event', this.analyticsService.searchCategory, {
	    event_category: 'engagement',
	    event_label: 'Searched with this term',
	    net_search: search,
	  });
	  if (facets) {
		this.analyticsService.trackSearchCollectionEvent(search, facets);		
	  }
  }
  
  private isOverflowedCandidate(): boolean{
	 let currentCriteria = Object.keys(this.searchService.criteria || {}).length > 0 ? this.searchService.criteria : {};
	 const estimateElementWidth = Object.values(currentCriteria)
     .reduce((sum, field: any) => sum + ((field.display_value?.length || 0) + (field.display_header?.length || 0) + 5)* 7.5, 0);
     const criteriaHolder = document.querySelector('.criteriaHolder');
     if(criteriaHolder instanceof HTMLElement){
		 return criteriaHolder.offsetWidth < estimateElementWidth + 200;
	 }
	 return false; 
  }
  
  /** TODO remove */
  removeCriteria(criteria: any) {
    //check if criteria has dependents. Remove those too
    //$rootScope.$broadcast("userTriggeredFacetUpdate", {category : facet, value : null});
  };	

  simpleSearch(event?: KeyboardEvent): void {
    if (event && event.key !== 'Enter') return;

    let query = this.states.query?.trim() || '*';
    let type = this.states.type?.trim() || '16';

    this.states.query = query;
    this.states.type = type;

    this.searchService.query = query;
    this.searchService.type = type;
    this.searchService.pageIndex = 1;

    this.searchService.removeFacetFlags(this.userService.user.searchInputs);
    this.searchService.broadcastEvent.emit({type:'userTriggeredCriteriaUpdate',data:this.userService.user.searchInputs});
	
    if(this.viewerMode === 'Filters') {
		this.onViewerModeChange('Results');
	}
  }

  removeFacet(key: string): void {
	if (key === 'facet-fields') {
	  this.searchService.setBrowseSearchFilter('');
      this.searchService.broadcastEvent.emit({type:'userTriggeredCriteriaUpdate',data:this.userService.user.searchInputs});
	} else {
	  const currType = this.userService.user?.searchInputs?.find(
	    x => x.name === key || `${x.name}_s` === key || `${x.name}_ss` === key
	  );
	  if (currType) {
	    let value: any;
	    if (currType.type && currType.type.toUpperCase() === 'LIST_MULTI') {
	      value = [];
	    } else if (currType.type === 'STRING') {
	      value = [{ content: null }];
	    } else {
	      value = null;
	    }
	    this.searchService.updateValue(currType, { content: value });
	    if (typeof currType.updateFn === 'function') {
	      currType.updateFn(currType);
	    }
	    currType.solrstring = null;
	    this.searchService.broadcastEvent.emit({type:'userTriggeredCriteriaUpdate',data:this.userService.user.searchInputs});
	  }
	}
  }
  
  setDefaultQueryType() {
	const params = { ...this.routingService.getQueryParams()};
    if (params['type']) {
        this.states.type = this.sanitize(params['type']);
    } else if (this.userService.user.properties) {
		const property = this.userService.user.properties.awpropertyObjectList?.find(
            (prop: any) => prop.name === 'QUERY_TYPE'
          );
        if(property){
			this.states.type = property.value;
		}  
    } else {
        this.states.type = "16";
    }
  }
  
  onSortChanged(args: any){
	 let field = this.validFieldsShow.find(f => f.name === args.field);

      if (field) {
        this.sort = {
          direction: args.direction === 'ASC' ? 'ASC' : 'DESC',
          field: field
        };
      } else {
        const defaultSort = this.userService.user.properties.awsortObjectList?.[0] ?? {
          fieldName: 'AW5_SORT_BY_FINE_RANK'
        };
        defaultSort.fieldName = defaultSort.fieldName?.length ? defaultSort.fieldName : 'AW5_SORT_BY_FINE_RANK';

        const defaultField = this.validFieldsShow.find(f => f.name === defaultSort.fieldName);
        let direction = defaultSort?.isAscending ?? null;

        if (direction === null) {
          direction = defaultField?.name !== 'AW5_SORT_BY_FINE_RANK';
        }

        this.sort = {
          direction: direction ? 'ASC' : 'DESC',
          field: defaultField
        };
      }
  }  
       	
 initializeProps(): void {
  let defaultField = false;	 
  if (this.userService.user.properties) {
    // Check for user sort properties
    if (this.userService.user.properties.awsortObjectList?.length > 0) {
      defaultField = true; //flag for the search service to use user sort properties
    }

    // Process property object list
    for (const prop in this.userService.user.properties.awpropertyObjectList) {
      if (Object.prototype.hasOwnProperty.call(this.userService.user.properties.awpropertyObjectList, prop)) {
        const property = this.userService.user.properties.awpropertyObjectList[prop];

        if (property.name === "NUMBER_DOCUMENTS_PER_PAGE") {
          this.pageSizes = property.optionElementList;
          this.pager.size = property.value;
          this.searchService.pageSize = property.value;
        }
      }
    }

    // Filter valid fields to show
    this.validFieldsShow = this.userService.user.properties.awfieldObjectList.filter(
      (x: any) =>
        (x.isAvailable && (x.isResult || x.name === "title")) ||
        x.name === "AW5_SORT_BY_FINE_RANK" ||
        x.name === "product_views"
    );
      
    // Generate sorted list
    let sortLst = this.userService.user.properties.awsortObjectList.map((sort: any) => {
      let find = this.userService.user.properties.awfieldObjectList.find(
        (field: any) => sort.fieldName === field.name
      );
      return find
        ? { ...find, isAscending: sort.isAscending }
        : sort.fieldName
        ? { name: sort.fieldName, displayName: sort.fieldName, isAscending: sort.isAscending }
        : undefined;
    });

    // Add sorted fields to validFieldsShow
    let sortLstIndex = 0;
    sortLst.forEach((s: any) => {
      if (s) {
        let fieldSort = { ...s };
        delete fieldSort.isAscending;

        const fieldFind = this.validFieldsShow.find((field: any) => field.name === fieldSort.name);
        if (sortLstIndex === 0) {
          this.defaultUserSort = s;
        } else if (!fieldFind) {
          this.validFieldsShow.unshift(s);
        }
        sortLstIndex++;
      }
    });

    // Handle Popularity field
    let popularityExistsIndex = this.validFieldsShow.findIndex((field: any) => field.name === this.popularity.name);
    if (popularityExistsIndex === -1 && this.docViewsEnabled) {
      this.validFieldsShow.push(this.popularity);
    } else if (popularityExistsIndex !== -1 && (!this.validFieldsShow[popularityExistsIndex].isAvailable || !this.validFieldsShow[popularityExistsIndex].isResult)) {
      this.validFieldsShow.splice(popularityExistsIndex, 1);
    }

    // Handle Rank field
    let rankExistsIndex = this.validFieldsShow.findIndex((field: any) => field.name === this.rank.name);
    if (rankExistsIndex === -1) {
      this.validFieldsShow.unshift(this.rank);
    } else if (!this.validFieldsShow[rankExistsIndex].isAvailable || !this.validFieldsShow[rankExistsIndex].isResult) {
      this.validFieldsShow.splice(rankExistsIndex, 1);
    }

    // Add default sort if missing
    if (defaultField && !this.validFieldsShow.find((field: any) => field.name === this.defaultUserSort.name)) {
      this.validFieldsShow.unshift(this.defaultUserSort);
    }

    // Check for additional icons property
    const additionalIconsProperty = this.userService.user.properties.awpropertyObjectList.find(
      (x: any) => x.name === "DISPLAY_ADDITIONAL_ICONS"
    );
    this.additionalIcons = additionalIconsProperty ? additionalIconsProperty.value === "true" : false;
    
    // set sort fields
    this.sortFieldsShow = this.validFieldsShow.filter((field: any) => 
    	!this.sortIsHidden(field)
    );
     
    // Change view if a view parameter is provided
    let defaultView = 'G';
    if(this.searchService.exitStates && this.searchService.exitStates.currentView){
		defaultView = this.searchService.exitStates.currentView;
	}
   	this.changeView(this.routingService.getQueryParam('v') || defaultView);
   	let defaultType = '16';
	if( this.searchService.exitStates.type){
		defaultType = this.searchService.exitStates.type;
		this.states.type = this.routingService.getQueryParam('type') || defaultType;
	}
  } else {
    this.validFieldsShow = this.docViewsEnabled ? [this.rank, this.popularity] : [this.rank];
    this.sortFieldsShow = this.validFieldsShow.filter((field: any) => 
    	!this.sortIsHidden(field)
    );
  }

  // Set default sorting
  const direction = defaultField && this.defaultUserSort?.isAscending ? "ASC" : "DESC";
  this.sortChanged(defaultField ? this.defaultUserSort : this.rank, direction, true);
 }
	
 toggleAdvanced () {
    this.states.advancedOpen = !this.states.advancedOpen;
    setTimeout(() => {
	    window.dispatchEvent(new Event('resize')); // Trigger resize event in Angular
	  }, 100);
    this.searchService.broadcastEvent.emit({type:'recordPreviewReset',data:{}});
 };

 setStatus(part: string | null): void {
    Object.keys(this.group).forEach((key) => {
      this.group[key] = key === part;
    });

    if (!part) {
      this.group['criteria'] = true;
    }
  }
 
 saveSearch(): void {
    const data = this.searchService.getSearchObject();
    this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    const mode = 'add';
	this.modalRef = this.ngbModal.open(SaveSearchComponent, {
		size: 'md'
	});
	this.modalRef.componentInstance.mode = mode;
	this.modalRef.componentInstance.searchData = data;
	this.modalRef.componentInstance.savedSearch = null;
	
	this.modalRef.result.then(
		(payload) => {
			if (payload.result?.answer === 'ok') {
				console.log('Modal SaveSearchComponent OK');
			}
		},
		(reason) => {
			console.log('Modal SaveSearchComponent dismissed');
		}
	);
  }
  
	globalSelectRecord(id: string) {
		this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash }; // Copy to trigger digest
		let index = this.globalRecordIds.indexOf(id);
		if (index > -1) {
			this.globalRecordIds.splice(index, 1);
		} else {
			this.globalRecordIds.push(id);
		}
		this.globalRecords.all = this.globalRecordIds.length == this.records.length;
	}  
  
//  globalSelectRecord_UNUSED(id: number, selected: boolean) {
//	let currentValue = this.globalRecordService.getRecord(id);
//	this.globalRecordService.setRecord(id, !currentValue);
//	this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash }; // Copy to trigger digest
//	
//    let index = this.globalRecordIds.indexOf(id.toString());
//    if (index > -1) {
//        this.globalRecordIds.splice(index, 1);
//    } else {
//        this.globalRecordIds.push(id.toString());
//    }
//    this.globalRecords.all = this.globalRecordIds.length == this.records.length;
//  }
  
  toggleCheckbox() {
	  if (this.globalRecords.all) {
	        this.selectAll();
	  } else {
	        this.deselectAll();
	  }
  };
	
  selectAll() {
	  this.searchService.broadcastEvent.emit({type:'globalrecordselectAll',data:{}});
	  this.globalRecordService.clear();
	  this.globalRecordIds = [];
	  for (let i = 0; i < this.records.length; i++) {
	      this.globalRecordService.setRecord(this.records[i].id, true);
	      this.globalRecordIds.push(this.records[i].id);
	  }
	  this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
	  this.globalRecords.all = true;
  };
	
  deselectAll() {
	 this.searchService.broadcastEvent.emit({type:'globalrecorddeselectAll',data:{}});
	 this.globalRecordService.clear();
	 this.globalRecordIdsHash = { ...this.globalRecordService.globalRecordIdsHash };
	 this.globalRecordIds = [];
	 this.globalRecords.all = false;
  };
  
  globalEdit() {
	this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    let productGroup = {
		records: this.records,
		ids: this.globalRecordIds
	};
    this.modalRef = this.ngbModal.open(GlobalEditComponent, {
		  size: 'md'
		});
		this.modalRef.componentInstance.browsepath = null;
		this.modalRef.componentInstance.productGroup = productGroup;

		// Handle modal close
	    this.modalRef.result.then(
		(payload: any) => {
			if (payload.result?.answer === 'ok') {
				console.log('Modal GlobalEditComponent OK');
			}
		},
		(reason: any) => {
			// Handle `reason` as a string or error object
		    if (typeof reason === 'string') {
		      console.log('GlobalEditComponent Modal dismissed:', reason);
		    } else if (reason instanceof Error) {
		      console.log('GlobalEditComponent Modal dismissed due to error:', reason.message);
		    } else {
		      console.log('GlobalEditComponent Modal dismissed for an unknown reason.');
		    }
		}
	    );
   };
  
   // Global Edit of browsepath values 
    globalBrowseEdit() {
		this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
		let productGroup = {
			records: this.records,
			ids: this.globalRecordIds
		};
		this.modalRef = this.ngbModal.open(BrowseEditComponent, {
		  size: 'md'
		});
		this.modalRef.componentInstance.browsepath = null;
		this.modalRef.componentInstance.productGroup = productGroup;

		// Handle modal close
	    this.modalRef.result.then(
		(payload: any) => {
			if (payload.result?.answer === 'ok') {
				console.log('Modal globalBrowseEdit OK');
			}
		},
		(reason: any) => {
			// Handle `reason` as a string or error object
		    if (typeof reason === 'string') {
		      console.log('Modal dismissed:', reason);
		    } else if (reason instanceof Error) {
		      console.log('Modal dismissed due to error:', reason.message);
		    } else {
		      console.log('Modal dismissed for an unknown reason.');
		    }
		}
	    );
    };
    
    moveToLibrary() {
        this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
        let productGroup = {
			ids : this.globalRecordIds,
		};
        this.modalRef = this.ngbModal.open(LibraryMoveComponent, {
		  size: 'md'
		});
		this.modalRef.componentInstance.productGroup = productGroup;
		this.modalRef.result.then(
		(payload: any) => {
			if (payload.result?.answer === 'ok') {
				console.log('Modal moveToLibrary OK');
			}
		},
		(reason: any) => {
			// Handle `reason` as a string or error object
		    if (typeof reason === 'string') {
		      console.log('Modal dismissed:', reason);
		    } else if (reason instanceof Error) {
		      console.log('Modal dismissed due to error:', reason.message);
		    } else {
		      console.log('Modal dismissed for an unknown reason.');
		    }
		}
	    );
    };
    
    rotateImage() {
        this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
        let productGroup = {
			ids : this.globalRecordIds,
		};
        this.modalRef = this.ngbModal.open(ImageRotateComponent, {
		  size: 'md'
		});
		this.modalRef.componentInstance.productGroup = productGroup;
		this.modalRef.result.then(
		(payload: any) => {
			if (payload.result?.answer === 'ok') {
				console.log('Modal ImageRotateComponent OK');
			}
		},
		(reason: any) => {
			// Handle `reason` as a string or error object
		    if (typeof reason === 'string') {
		      console.log('Modal dismissed:', reason);
		    } else if (reason instanceof Error) {
		      console.log('Modal dismissed due to error:', reason.message);
		    } else {
		      console.log('Modal dismissed for an unknown reason.');
		    }
		}
	    );
    };
    
    globalDelete() {
		this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
        this.modalRef = this.ngbModal.open(ConfirmComponent, {
			size: 'md'
		});
		this.modalRef.componentInstance.modal = {
			callerName: 'globalDelete',
			title: this.LOCALIZATION.deleteDocumentsHeader,
			message: this.LOCALIZATION.deleteDocumentsMessage,
			type: 'danger'
	  };
	  this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	      this.productService.deleteDocuments(this.globalRecordIds).then(
	        (response: any) => {
	          this.alertsService.success({
	            message: this.LOCALIZATION.searchUpdatesConfirmationMessage,
	            delay: 5000
	          });
	          this.deselectAll();
	        },
	        () => {
	          this.alertsService.error({
	            message: this.LOCALIZATION.deleteDocumentsError,
	          });
	        }
	      );
	    }
	  },
	  (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  };
  
	ocrDocuments() {
		this.searchService.broadcastEvent.emit({ type: 'closeModal', data: {} });
		
		this.modalRef = this.ngbModal.open(ConfirmComponent, {
			size: 'md'
		});
		this.modalRef.componentInstance.modal = {
			callerName: 'ocrDocuments',
			title: this.LOCALIZATION.ocrDocumentsHeader,
			message: this.LOCALIZATION.ocrDocumentsMessage,
			type: "primary"
		};
		this.modalRef.result.then(
			(payload: any) => {
				if (payload.result?.answer === 'ok') {
					if (this.globalRecordIds.length > 50) {
						this.alertsService.info({
						    message: this.LOCALIZATION.processingWaitMessage
						});  
					}
					
					this.productService.ocrDocuments(this.globalRecordIds).then(
						(response: any) => {
							this.alertsService.success({
								message: this.LOCALIZATION.ocrDocumentsSuccess,
								delay: 5000
							});
						},
						(err: any) => {
							console.error("Failed to OCR documents: ", err);
							this.alertsService.error({
								message: this.LOCALIZATION.ocrDocumentsError
							});
						}
					);
				}
			},
			(reason: any) => {
				if (typeof reason === 'string') {
					console.log('Modal dismissed:', reason);
				} else if (reason instanceof Error) {
					console.log('Modal dismissed due to error:', reason.message);
				} else {
					console.log('Modal dismissed for an unknown reason.');
				}
			}
		);
	}
  
  sendProducts(){
    this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    if (this.globalRecordIds.length == 0) {
        this.selectAll();
    }
    let productGroup = {
      ids: this.globalRecordIds,
      title: this.LOCALIZATION.emailResults
    }
    this.modalRef = this.ngbModal.open(EmailProductsComponent, {
		  size: 'md'
		});
	this.modalRef.componentInstance.productGroup = productGroup;
		
	this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	    }
	 },
	 (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  };
  
  printProductResults(){
    this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    if (this.globalRecordIds.length == 0) {
        this.selectAll();
    }
    let productGroup = {
		ids: this.globalRecordIds
	};
    this.modalRef = this.ngbModal.open(PrintResultsComponent, {
		  size: 'md'
		});
	this.modalRef.componentInstance.productGroup = productGroup;
		
	this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	    }
	 },
	 (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  };
  
  compareProducts(){
    let products = [];
    for (let i = 0; i < this.globalRecordIds.length; i++) {
        for (let j = 0; j < this.records.length; j++) {
            if (this.records[j].id == this.globalRecordIds[i]) {
                products.push({
                    id: this.globalRecordIds[i],
                    title: this.records[j].title,
                    record: this.records[j]
                });
            }
        }
    }
	
	const modalRef = this.ngbModal.open(DiffViewerComponent, {
		windowClass: 'viewer-modal-window'
	});

	modalRef.componentInstance.products = products;

	modalRef.result.then(
		(payload) => {
			console.log('Modal dismissed');
		},
		(reason) => {
			console.log('Modal dismissed');
		}
	);	
  }
  
  downloadProducts(){
    this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    this.modalRef = this.ngbModal.open(MassDownloadComponent, {
		  size: 'md'
		});
	let productGroup = {
		ids: this.globalRecordIds
	};
	this.modalRef.componentInstance.productGroup = productGroup;
	this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	    }
	 },
	 (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  }
  
  geotag(wkt?: string) {
    if (this.globalRecordIds && this.globalRecordIds.length > 0) {
        let records = this.records.filter((record)=> {
            if (this.globalRecordIds.indexOf(record.id) > -1) {
                return record;
            }
        });
		
		const modalRef = this.ngbModal.open(GeoTagComponent, {
			size: 'lg',
			windowClass: 'kv-utility-modal kv-utility-large-modal-window',
			animation: false
		});
		
		modalRef.componentInstance.productGroup = {
			commit: true,
			records: records
		};		
		
		modalRef.result.then(
			(payload) => {
				console.log('Modal dismissed');
			},
			(reason) => {
				console.log('Modal dismissed');
			}
		);
    }
  }
  
  dxBatchAdd(){
    this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    let selected = Object.keys(this.globalRecordIdsHash).filter((key:string) => {
        return this.globalRecordIdsHash[key]
    });

    let productGroup = {
		records: this.records,
		ids: selected
	}
    this.modalRef = this.ngbModal.open(BatchAddComponent, {
		  size: 'md'
		});
	this.modalRef.componentInstance.productGroup = productGroup;
	this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	    }
	 },
	 (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  }
  
  addRecordsToAlbum() {
	this.processAlbumRecords('add');
  }

  removeRecordsFromAlbum() {
	this.processAlbumRecords('remove');
  }
  
  processAlbumRecords(mode: string): void {
   const ids = this.globalRecordIds;
   const records = ids.map((id, index) => {
    return {
      name: "",
      uuid: id,
      type: "STANDARD",
      page: 0,
      sheet: 0,
      id: this.records[index].id
    };
   });
   let albumItems = {
	   mode: mode,
	   records: records
   }
   this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
   this.modalRef = this.ngbModal.open(AlbumItemComponent, {
		  size: 'md'
	});
	this.modalRef.componentInstance.albumItems = albumItems;
	this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	    }
	 },
	 (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
 }
 
 fileAsRMRecords(){
    this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    let selected = Object.keys(this.globalRecordIdsHash).filter((key: string)=> {
        return this.globalRecordIdsHash[key]
    });

    let productGroup = {
     ids: selected,
     records: this.records
    };
   this.modalRef = this.ngbModal.open(RecordFilingComponent, {
		  size: 'md'
	});
	this.modalRef.componentInstance.productGroup = productGroup;
	this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	    }
	 },
	 (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  }
  
  completeRMRecords(isCompleted: boolean) {
	this.filingService.updateRecordCompleteStatus(this.globalRecordIds, isCompleted, false).then(
      (response: any) => {
      this.alertsService.success({
        message: this.LOCALIZATION.completeRMRecordsSuccess,
        delay: 5000
      });
    },
    () => {
      this.alertsService.error({
        message: this.LOCALIZATION.completeRMRecordsError
      });
    });		
  }
 
	generateThumbnails() {
		this.searchService.broadcastEvent.emit({ type: 'closeModal', data: {} });
		
		this.modalRef = this.ngbModal.open(ConfirmComponent, {
			size: 'md'
		});
		this.modalRef.componentInstance.modal = {
			callerName: 'generateThumbnails',
			title: this.LOCALIZATION.thumbnailsCreateHeader,
			message: this.LOCALIZATION.thumbnailsCreateMessage,
			type: "primary"
		};
		this.modalRef.result.then(
			(payload: any) => {
				if (payload.result?.answer === 'ok') {
					if (this.globalRecordIds.length > 50) {
						this.alertsService.info({
						    message: this.LOCALIZATION.processingWaitMessage
						});  
					}
					
					this.productService.generateThumbnails(this.globalRecordIds).then(
						(response: any) => {
							this.alertsService.success({
								message: this.LOCALIZATION.searchUpdatesConfirmationMessage,
								delay: 5000
							});
							this.deselectAll();
						},
						(error: any) => {
							console.error("Thumbnail generation failed: ", error);
							this.alertsService.error({
								message: this.LOCALIZATION.thumbnailsCreateError,
							});
						}
					);
				}
			},
			(reason: any) => {
				if (typeof reason === 'string') {
					console.log('Modal dismissed:', reason);
				} else if (reason instanceof Error) {
					console.log('Modal dismissed due to error:', reason.message);
				} else {
					console.log('Modal dismissed for an unknown reason.');
				}
			}
		);
	}
 
 onCloseModal(){
	if (this.modalRef) {
	  this.modalRef.dismiss('cancel');
	  this.modalRef = undefined;
	}	 
 }
 
 createCitations () {
    this.searchService.broadcastEvent.emit({type:'closeModal',data:{}});
    let citations = [];
    for (let i = 0; i < this.globalRecordIds.length; i++) {
        let record = (this.searchResults && this.searchResults.records)?this.searchResults.records.find((x: any) => { return x.id == this.globalRecordIds[i] }):[];
        if (record && !(record instanceof Array)) {
           const citationItem = { ...record };
           citationItem.title = citationItem._title; //use raw format title;
           citations.push(citationItem);
        }
    }
    this.modalRef = this.ngbModal.open(CitationComponent, {
		  size: 'md'
	});
	this.modalRef.componentInstance.productGroup = citations;
	this.modalRef.result.then(
	  (payload: any) => {
	    if (payload.result?.answer === 'ok') {
	    }
	 },
	 (reason: any) => {
	    // Handle `reason` as a string or error object
	    if (typeof reason === 'string') {
	      console.log('Modal dismissed:', reason);
	    } else if (reason instanceof Error) {
	      console.log('Modal dismissed due to error:', reason.message);
	    } else {
	      console.log('Modal dismissed for an unknown reason.');
	    }
	  }
	);
  }
 
  onTypeChange(newValue: string) {
    this.setSortField(this.sort?.field, this.sort?.direction);
  }
 
  sanitize(value: string): string {
    return this.sanitizer.sanitize(1, value) || ''; // 1 = SecurityContext.HTML
  } 
  
  setDefaultValues(){
	  		this.popularity = {
	        name: "product_views",
	        displayName: this.LOCALIZATION && this.LOCALIZATION.popularity ? this.LOCALIZATION.popularity : "Popularity",
	        defaultValue: null,
	        isAvailable: true,
	        isDefaultResult: false,
	        isDefaultSearch: false,
	        isDefaultMetadata: false,
	        isResult: true,
	        isSearch: true,
	        isMetadata: true,
	        isLink: false,
	        nodeName: null,
	        type: null
	    };
	    this.rank = {
	        name: "AW5_SORT_BY_FINE_RANK",
	        displayName: this.LOCALIZATION && this.LOCALIZATION.rank ? this.LOCALIZATION.rank : "Rank",
	        defaultValue: null,
	        isAvailable: true,
	        isDefaultResult: false,
	        isDefaultSearch: false,
	        isDefaultMetadata: false,
	        isResult: true,
	        isSearch: true,
	        isMetadata: true,
	        isLink: false,
	        nodeName: null,
	        type: null
	    };
	    this.defaultUserSort = {
	        name: "Default",
	        displayName: this.LOCALIZATION.defaultVal
	    };
  }
  
  setFromConfiguration(): void{
	this.projectionUnits = this.configService.getConfig().esri?.projections;
    this.mapViewEnabled = this.configService.getConfig().esri?.enabled;
    this.aiServicesEnabled = this.configService.getConfig().ai ? this.configService.getConfig().ai.enabled : false;
    this.recordsMgmtServicesEnabled = this.configService.getConfig().recordsManagement ? this.configService.getConfig().recordsManagement.enabled : false;
    this.docViewsEnabled = this.configService.getConfig().viewer ? this.configService.getConfig().viewer.docViewsEnabled : false;
    this.simpleview = this.configService.getConfig().simpleResultView;
    this.isMoreLikeThisEnabled = this.configService.getConfig().search.isMoreLikeThis;
    this.streamingQueries = this.configService.getConfig().search.streamingQueries;
    this.dxOn = this.configService.getConfig().dx.enabled;
    this.multiFacetSearch = this.configService.getConfig().search.multiFacetSearch || false;
    let multiFacetBlacklistStr = (this.configService.getConfig().search && this.configService.getConfig().search.multiFacetSearchBlacklist) ? this.configService.getConfig().search.multiFacetSearchBlacklist : "";
	this.multiFacetBlacklist = multiFacetBlacklistStr.split(',').map((item: string) => {
	    return item.trim();
	});
	this.paginationGoTo = this.configService.getConfig().search.goToPage || false;
  }
  
  // Handle the selection changes manually, if needed
  onViewerModeChange(newValue: string, dropdown?: NgbDropdown) {
    console.log('Viewer Mode changed to:', newValue);
    this.viewerMode = newValue; // Ensure that the value is updated correctly
    dropdown?.close();
  }
  
  canEdit(): boolean {
	return this.userPermissions['ROLE_PRODUCT_UPDATE'] &&
	       this.globalRecordIds.length > 0 &&
	       this.globalRecordIds.length <= 500;
  }
	
  canDelete(): boolean {
	return this.userPermissions['ROLE_PRODUCT_DELETE'] &&
	       this.globalRecordIds.length > 0 &&
	       this.globalRecordIds.length <= 500;
  }
	
  canDownload(): boolean {
	return (
	  this.userPermissions['ROLE_ORDER_MANAGEMENT'] ||
	  this.userPermissions['ROLE_ORDER_VIEW'] ||
	  this.userPermissions['ROLE_PRODUCT_DOWNLOAD']
	);
   }
  
  decode(val: string): string {
    return decodeURIComponent(val);
  }
  
  isFeatureEnabled(feature: string): boolean {
  	return this.featureService.isFeatureEnabled(feature);
  }  
  
  openBrowseLink(args: any){
  }
}
